import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

export const Campaigns = ({ reload }) => {
  const api = useApi();
  const [list, setList] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () => api("get", "/ai/campaigns").then((l) => { if (alive) { setList(l); } }).catch(() => {});
    load();
    const t = setInterval(load, 4000);
    return () => { alive = false; clearInterval(t); };
  }, [api, reload]);
  if (!list.length) { return null; }
  return (
    <div className="pt-3 border-t border-stone-100" data-testid="ai-campaigns">
      <p className="text-xs uppercase tracking-[0.15em] text-stone-500 mb-1">Derniers envois</p>
      {list.map((c) => (
        <p key={c.id} className="py-1 text-stone-700" data-testid={`ai-campaign-${c.id}`}>
          <span className="font-medium">{c.subject}</span> · {c.sent}/{c.count} envoyés{c.failed ? `, ${c.failed} échec(s)` : ""} · {c.status} · {new Date(c.at).toLocaleString("fr-FR")}
        </p>
      ))}
    </div>
  );
};
